const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';


const innotechObservedReveals = new WeakSet();

function prepareInnotechReveals(rootEl) {
  const candidates = rootEl.querySelectorAll('main h1, main h2, main h3, main h4, main h5, main h6, main p, main .rte, main details, main .ioa__step, main .it-apart__card, main .imv-card__content, main .it-card__body');
  candidates.forEach((element) => {
    if (!element.textContent.trim() || element.closest('nav, [role="navigation"], .slideshow, .visually-hidden, [hidden], [data-innotech-reveal="off"]')) return;
    if (element.matches('.rte') && element.textContent.length > 1200) return;
    if (element.closest('.scroll-trigger') || element.querySelector('.scroll-trigger')) return;
    if (getComputedStyle(element).position === 'sticky' || getComputedStyle(element).position === 'fixed') return;
    element.classList.add('scroll-trigger', 'animate--slide-in', 'innotech-site-reveal');
  });
  rootEl.querySelectorAll('main .scroll-trigger.animate--slide-in').forEach((element) => {
    element.style.setProperty('--animation-slide-in', 'slideIn 800ms var(--ease-out-slow) forwards');
    element.style.setProperty('animation-duration', '800ms');
    if (!element.style.getPropertyValue('--animation-order')) element.style.setProperty('--animation-order', '0');
  });
}

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.style.setProperty('--animation-order', Math.min(index, 3));
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  prepareInnotechReveals(rootEl);
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)).filter((element) => isDesignModeEvent || !innotechObservedReveals.has(element));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    animationTriggerElements.forEach((element) => {
      element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => {
    innotechObservedReveals.add(element);
    observer.observe(element);
  });
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
  const main = document.querySelector('main');
  if (main) {
    const updates = new MutationObserver((records) => {
      if (records.some((record) => Array.from(record.addedNodes).some((node) => node.nodeType === 1))) {
        initializeScrollAnimationTrigger(document, Boolean(window.Shopify && Shopify.designMode));
      }
    });
    updates.observe(main.parentElement, { childList: true, subtree: true });
  }
  document.addEventListener('focusin', (event) => {
    const target = event.target.closest('main .scroll-trigger');
    if (target) {
      target.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      target.classList.add(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
